export const delimiter = '/';